<template>
    <g fill-rule="evenodd">
        <path d="M13.125 16.764V2.83c-.44-.441-1.81-.441-2.25 0v13.933l-1.537-1.632c-.327-.347-.874-.354-1.21-.017l-.38.383c-.33.331-.33.868 0 1.199l3.457 3.472c.439.441 1.151.441 1.59 0l3.458-3.472c.33-.331.33-.868 0-1.199l-.381-.383c-.336-.337-.883-.33-1.21.017l-1.537 1.632z" transform="translate(-656 -477) translate(653 470) matrix(0 1 1 0 .5 -.5)"/>
    </g>
</template>

<script>
export default {
    name: 'arrowSortRightIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 18 9');
    }
};
</script>
